"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _actionUtils = require("../../utils/actionUtils");
var _types = require("./types");
/**
 * Creates an action to add a tile to an attendee in a meeting
 *
 * @param {string} attendeeId - The unique identifier of the attendee
 * @param {Object} attendeeTile - The tile data to add to the attendee
 * @returns {Object} An action object with type and payload
 */
var addToAttendeeTiles = function addToAttendeeTiles(attendeeId, attendeeTile) {
  return (0, _actionUtils.actionCreator)(_types.ADD_TO_ATTENDEE_TILES, {
    attendeeId: attendeeId,
    attendeeTile: attendeeTile
  });
};
var _default = exports["default"] = addToAttendeeTiles;